import { useCompleteTrackingContext } from '@hc-frontend/features-tracking';
import Script from 'next/script';
import { useEffect, useState } from 'react';

export function CriteoGum() {
  const { tracker } = useCompleteTrackingContext();
  const [srcUrl, setSrcUrl] = useState<string>('');

  useEffect(() => {
    const domainUserId = tracker.getDomainUserId();
    setSrcUrl(
      `https://gum.criteo.com/fpm/init?first_party_id=${domainUserId}&first_party_domain=healthcare.com&first_party_name=HealthCare.com&p=24273`,
    );
  }, [tracker]);

  if (srcUrl) {
    return (
      <>
        <Script strategy="lazyOnload" id="criteo-gum-pixel" src={srcUrl} />
      </>
    );
  } else {
    return null;
  }
}
